import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getDoctoralCommitteeOptions } from '@/module/Author/DoctoralCommittee';
import { DoctoralCommitteeEdit } from '@/module/Author/DoctoralCommittee/DoctoralCommitteeEdit';

export const Route = createFileRoute(
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { doctoralCommitteeId } = Route.useParams();
  const { data: doctoralCommittee } = useSuspenseQuery(getDoctoralCommitteeOptions(doctoralCommitteeId));

  return <DoctoralCommitteeEdit doctoralCommittee={doctoralCommittee} />;
}
